import { useState } from 'react';

import PropTypes from 'prop-types';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import TabContext from '@zenbusiness/zui/TabContext';
import TabPanel from '@zenbusiness/zui/TabPanel';

import BenefitsItem from './BenefitsItem';
import BenefitsList from './BenefitsList';
import * as Styled from './BenefitsSection.style';

import { useProductLandingClickstreamProps } from '../../hooks/useProductLandingClickstreamProps';

function BenefitsTabList({ items, defaultValue }) {
  const categories = Object.keys(items);
  const [value, setValue] = useState(defaultValue || categories[0]);
  const personalizationClickstreamProps = useProductLandingClickstreamProps();
  const trackTabChange = useButtonPressedCallback({
    ...personalizationClickstreamProps,
    elementName: 'benefits_tab_list',
  });

  const handleChange = (event, newValue) => {
    trackTabChange(event);
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <Styled.BenefitsTabList onChange={handleChange} aria-label="Benefits categories">
        {categories.map((category) => (
          <Styled.BenefitsTab key={category} label={<FormattedMessage id={category} />} value={category} />
        ))}
      </Styled.BenefitsTabList>
      {categories.map((category) => (
        <TabPanel key={category} value={category}>
          <BenefitsList items={items[category]} />
        </TabPanel>
      ))}
    </TabContext>
  );
}

BenefitsTabList.propTypes = {
  items: PropTypes.objectOf(PropTypes.arrayOf(BenefitsItem.propTypes.item)).isRequired,
  defaultValue: PropTypes.string,
};

export default BenefitsTabList;
